export default __webpack_public_path__ + "static/media/9.89cb01af.png";